var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolTipTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.268 0.999999C11.0378 -0.333335 12.9623 -0.333333 13.7321 1L23.2583 17.5C24.0281 18.8333 23.0659 20.5 21.5263 20.5H2.47372C0.934118 20.5 -0.0281308 18.8333 0.74167 17.5L10.268 0.999999Z",
    fill: "#0B1C56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTipTop);
export default __webpack_public_path__ + "static/media/toolTipTop.4caf3ab1290c68ee8efb4c2abecc99e4.svg";
export { ForwardRef as ReactComponent };